module.exports = __webpack_public_path__ + "assets/img/a722563cafbda38314f37ac7a2a22cf7.webp";